<template>
  <dx-modal
    id="update-cbhpm-modal"
    title="Atualização via CBHPM"
    size="lg"
    :value="true"
    @input="close"
  >
    <div class="loading loading-lg" v-if="loading" />
    <template v-else>
      <div class="h6 text-secondary">Despesas</div>
      <table class="table table-hover">
        <thead>
        <tr>
          <th class="text-center">
            <fa-icon class="text-info" :icon="['fal', 'info-circle']" />
          </th>
          <th>Código</th>
          <th>Nome</th>
          <th class="text-right">Valor atual</th>
          <th class="text-right">Novo valor</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, i) in expenses" :key="i">
          <td class="text-center">
            <span class="tooltip tooltip-right" data-tooltip="Será atualizado"
                  v-if="item.definition.updateValuesByCbhpm
                   && item.definition.newInsuranceValue">
              <fa-icon class="text-success" :icon="['fal', 'check-circle']" />
            </span>
            <span class="tooltip tooltip-right"
                  data-tooltip="Bloqueado para atualizações"
                  v-else-if="!item.definition.updateValuesByCbhpm">
              <fa-icon class="text-warning" :icon="['fal', 'lock']" />
            </span>
            <span class="tooltip tooltip-right"
                  data-tooltip="Preço não encontrado na tabela"
                  v-else>
              <fa-icon class="text-error" :icon="['fal', 'times-circle']" />
            </span>
          </td>
          <td>{{ item.code | tuss }}</td>
          <td>{{ item.name }}</td>
          <td class="text-right">{{ item.definition.insuranceValue | currency }}</td>
          <td class="text-right">
            <strong class="text-secondary"
                    v-if="item.definition.updateValuesByCbhpm
                    && item.definition.newInsuranceValue">
              {{ item.definition.newInsuranceValue | currency }}
            </strong>
            <strong class="text-center tooltip tooltip-left"
                    data-tooltip="Bloqueado para atualizações"
                    v-else-if="!item.definition.updateValuesByCbhpm">
              <fa-icon class="text-warning" :icon="['fal', 'lock']" />
            </strong>
            <strong class="text-error text-center tooltip tooltip-left"
                    data-tooltip="Preço não encontrado na tabela"
                    v-else>N/A</strong>
          </td>
        </tr>
        </tbody>
      </table>
    </template>
    <template v-slot:footer>
      <button class="btn btn-primary btn-icon btn-icon-left mr-1"
              @click="save">
        <fa-icon :icon="['fal', 'check']" />Atualizar
      </button>
      <button class="btn" @click="close">Sair</button>
    </template>
  </dx-modal>
</template>

<script>
import { clearNonNumbers } from '@/helpers/string';

export default {
  props: {
    cbhpm: {
      type: Object,
      required: true,
    },
    items: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      expenses: [],
      cbhpmExpenses: [],
      loading: false,
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    async init() {
      this.loading = true;
      await this.loadExpenses();
      await this.loadCbhpmExpenses();
      this.setNewInsuranceValue();
      this.loading = false;
    },
    async loadExpenses() {
      this.expenses = [...this.items
        .filter(item => item.code
          && item.definition.updateValuesByCbhpm
          && !['medicine', 'material'].includes(item.expense.type))
        .map(item => ({
          id: item.expense.id,
          code: item.code,
          name: item.expense.name,
          type: item.expense.type,
          definition: item.definition,
        }))];
      await this.$nextTick();
    },
    loadCbhpmExpenses() {
      const params = {
        edition: this.cbhpm.editionCode,
        codes: this.expenses.map(({ code }) => clearNonNumbers(code)).join(','),
      };

      return this.$http.get('/cbhpm-expenses', { params })
        .then(({ data }) => {
          this.cbhpmExpenses = data.items;
        })
        .catch(() => {});
    },
    setNewInsuranceValue() {
      this.expenses.forEach((item) => {
        const foundCbhpmItem = this.cbhpmExpenses
          .find(({ code }) => code === clearNonNumbers(item.code));

        if (foundCbhpmItem) {
          const foundPostage = this.cbhpm.postageItems
            .find(({ postage }) => postage === foundCbhpmItem.postage.postage);

          const procedureFilm = this.cbhpm.film || 0;
          const procedureOperationalCost = this.cbhpm.operationalCost || 0;
          const cbhpmFilmQtd = foundCbhpmItem.film || 0;
          const filmValue = (procedureFilm * cbhpmFilmQtd) || 0;
          const cbhpmOperationalCost = foundCbhpmItem.operationalCost || 0;
          const cbhpmFraction = foundCbhpmItem.postage.fraction || 1;
          const feeValue = (foundPostage.value * cbhpmFraction) || 0;
          const operationalCost = (procedureOperationalCost * cbhpmOperationalCost);
          item.definition.filmQuantity = cbhpmFilmQtd;
          item.definition.filmValue = filmValue;
          item.definition.operationalCostValue = operationalCost;
          item.definition.feeValue = feeValue;
          item.definition.newInsuranceValue = (
            operationalCost + filmValue + feeValue
          );
        }
      });
    },
    close() {
      this.$emit('close');
    },
    save() {
      this.$dialog.show('', {
        html:
          '<div class="text-center">'
          + '<h5 class="text-center">Atenção!</h5>'
          + '<div>Deseja realmente atualizar os valores da tabela?</div>'
          + '</div>',
        buttons: [
          {
            label: 'Não',
            classes: '',
          }, {
            label: 'Sim',
            classes: 'btn-primary btn-error ml-2',
            click: (close) => {
              close();
              this.$emit('save', this.expenses
                .filter(({ definition }) => definition.newInsuranceValue));
            },
          },
        ],
      });
    },
  },
};
</script>
